import './styles';

import React from 'react';
import SharedHeader from 'shared/components/header';
import HeaderButtonBar from 'details/components/details_page/header_button_bar';

export default class Header extends React.Component {
    render() {
        return (
            <SharedHeader className="Header-wrapper">
                <div className="Header">
                    <HeaderButtonBar rootURL={this.props.rootURL} publication={this.props.publication} />
                </div>
            </SharedHeader>
        );
    }
}
